export default __webpack_public_path__ + "static/end_4-ddd95c7562bc05864f0469cd74950882.png";